import * as React from "react";
const OrderContext = React.createContext(null);
OrderContext.displayName = "OrderContext";
const useOrder = () => {
  const context = React.useContext(OrderContext);
  if (!context) {
    throw new Error(
      "No Order available. You might still need to wrap the application with the OrderProvider component."
    );
  }
  return context;
};
export {
  OrderContext,
  useOrder
};
//# sourceMappingURL=context.js.map
